import { render, staticRenderFns } from "./liList.vue?vue&type=template&id=2c806731&scoped=true&"
import script from "./liList.vue?vue&type=script&lang=js&"
export * from "./liList.vue?vue&type=script&lang=js&"
import style0 from "./liList.vue?vue&type=style&index=0&id=2c806731&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c806731",
  null
  
)

export default component.exports